import { translationOrganizations_en_part1 } from "./translationOrganizations.en.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationOrganizations_en_part2 } from "./translationOrganizations.en.part2";
import { translationOrganizations_en_part3 } from "./translationOrganizations.en.part3";

export const translationOrganizations_en = defineTranslationTree({
  ...translationOrganizations_en_part1,
  ...translationOrganizations_en_part2,
  ...translationOrganizations_en_part3,
});
